frappe.provide("eternal_support");

eternal_support.uploadFile = function (file, file_name, opts = {}) {
	return new Promise((resolve, reject) => {
		const xhr = new XMLHttpRequest();
		xhr.upload.addEventListener("loadstart", () => {
			frappe.show_alert({
				indicator: "green",
				message: opts.start_label || __("Uploading file"),
			});
		});
		xhr.upload.addEventListener("progress", (e) => {
			if (e.lengthComputable) {
				frappe.show_progress(
					opts.progress_title || "Uploading",
					e.loaded,
					e.total,
					"",
					true
				);
			}
		});
		xhr.addEventListener("error", (e) => {
			console.error(e);
			frappe.show_alert(
				{
					indicator: "red",
					message: __("Unable to upload file. Please retry."),
				},
				5
			);
			reject();
		});
		xhr.onreadystatechange = () => {
			if (xhr.readyState === XMLHttpRequest.DONE) {
				if (xhr.status === 200) {
					try {
						const r = JSON.parse(xhr.responseText);
						if (r.message.doctype === "File") {
							return resolve(r.message.file_url);
						}
					} catch (error) {
						console.error(error);
					}
				}

				frappe.show_alert(
					{
						indicator: "red",
						message: __("Unable to upload file. Please retry."),
					},
					5
				);
				reject();
			}
		};

		xhr.open("POST", "/api/method/upload_file", true);
		xhr.setRequestHeader("Accept", "application/json");
		xhr.setRequestHeader("X-Frappe-CSRF-Token", frappe.csrf_token);

		const form_data = new FormData();
		form_data.append(
			"file",
			file,
			file_name || file.name || `eternal-support-${Date.now()}.webm`
		);
		form_data.append("is_private", frappe.boot.eternal_support?.file_privacy ? 1 : 0);
		form_data.append("folder", "Home/Eternal Support");

		xhr.send(form_data);
	});
};
